const Search = (state="", action) => {
    switch (action.type){
        case 'SEARCH' :
            return action.payload;
    }
    return state;
}

export default Search;


// WEBPACK FOOTER //
// ./src/reducers/Search.js